// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_4C-","cls2":"NewsInteractionBar-cls2_t0c NewsInteractionBar-cls1_4C-"};